// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L6 8h3v8H6l6 6l6-6h-3V8h3L12 2z\" /></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagina-pedidos.contenedorprincipal {
  width: 95%;
  margin: 0 auto;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
  position: relative; /* [EXPERT_FIX]: Necesario para que el resumen de estados se ancle aquí */
}

.pagina-pedidos .titulo {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 2px;
}

.pagina-pedidos .botonessuperiores {
  display: flex; /* Usamos flexbox para alinear los botones */
  justify-content: center; /* Centramos los botones horizontalmente */
  gap: 5px; /* Espaciado entre los botones */
  margin-bottom: 15px; /* Espaciado inferior para separar de otros elementos */
}

.botonessuperiores .p-button {
  padding: 5px 10px; /* Reduce el padding interno de los botones */
  font-size: 14px; /* tamaño del texto de los botones*/
}

.fila-seleccionada {
  background-color: #e0f7fa !important;
}

/**************************ESTILOS PARA LOS ESTADOS DE LISTA PEDIDOS***************

/* Estilo base para todos los estados */
.estado {
  display: block; /* Se comporta como un bloque que ocupa todo el ancho disponible */
  width: 100%; /* Ocupa el 100% del ancho de la celda */
  text-align: center; /* Centrar el texto dentro del fondo */
  background-color: #d9d9d9; /* Fondo gris claro */
  padding: 4px 2px; /* Espaciado interno optimizado */
  font-weight: bold; /* Negrita para el texto */
  border-radius: 5px; /* Bordes redondeados */
  box-sizing: border-box; /* Asegura que el padding no afecte el ancho total */
  font-size: 0.85rem; /* Tamaño de fuente ligeramente reducido */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Colores específicos según el estado */
.estado-creado {
  color: blue;
}

.estado-le-ok {
  color: green;
}

.estado-le-aprobada {
  color: rgb(255, 0, 0);
}

.estado-asignado {
  color: darkorange;
}

.estado-cargado {
  color: purple;
}

.estado-despachado {
  color: rgb(129, 238, 129);
}

.estado-parcialmente-asignado {
  color: #ff9800;
}

.estado-parcialmente-cargado {
  color: #9c27b0;
}

.estado-parcialmente-despachado {
  color: #f44336;
}

/*************Resumen estado pedidos***************/
/* [EXPERT_FIX]: Renombrado a -panel para evitar cache y conflictos */
.resumen-estados-panel {
  /* Position absolute eliminado, manejado por wrapper en JSX */
  width: 250px;
  padding: 5px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 0.9rem;
}

/* Media query para pantallas medianas y pequeñas */
@media (max-width: 1024px) {
  .resumen-estados-panel {
    width: 100%; /* Ocupa todo el ancho disponible */
    max-width: 100%;
    margin-top: 10px;
  }
}

.resumen-estado-item {
  display: flex;
  align-items: center;
  gap: 8px; /* Espaciado entre el ícono y el nombre */
  padding: 2px 0;
}

.p-datatable-header {
  padding: 0.5rem;
}

/* [EXPERT] Forzar layout para que el ancho de las columnas se respete y permita scroll horizontal */
.pagina-pedidos .p-datatable .p-datatable-wrapper table {
  table-layout: fixed !important; /* Cambiado de auto a fixed para mayor estabilidad */
  min-width: 100%; /* Asegura que cubra al menos el ancho disponible */
}

/* [EXPERT] Establecer altura mínima para que el paginador no salte al buscar */
.pagina-pedidos .p-datatable .p-datatable-wrapper {
  min-height: 350px; /* Reducido para asegurar visibilidad del paginador al 100% */
}

.p-datatable .p-datatable-scrollable-header-table,
.p-datatable .p-datatable-scrollable-body-table {
  table-layout: fixed !important;
}

/* [EXPERT] Forzar que los encabezados de la tabla mantengan dos líneas y no colapsen */
.pagina-pedidos .p-datatable .p-datatable-thead > tr > th {
  white-space: normal !important; /* Permite saltos de línea */
  word-wrap: break-word !important;
  vertical-align: middle !important;
  text-align: center !important;
  padding: 0.35rem !important;
}

/* [EXPERT_UI]: Ajuste de layout seguro para encabezados */
.p-datatable .p-datatable-thead > tr > th .p-column-header-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important; /* Más espacio entre texto e icono */
  padding: 0.35rem 0.2rem !important;
  position: relative; /* Para posicionamiento fino si fuera necesario */
}

/* [EXPERT_UI]: Estilización de Iconos de Ordenamiento "Más Estéticos" */
.p-datatable .p-sortable-column-icon {
  font-size: 0.75rem !important; /* Icono más pequeño y elegante */
  color: #999 !important; /* Color gris suave, menos agresivo */
  margin-left: 0 !important; /* Reset de margenes */
  opacity: 0.7;
  transition: all 0.2s ease;
}

/* Estado activo (columna ordenada) */
.p-datatable .p-datatable-thead > tr > th.p-highlight .p-sortable-column-icon {
  color: #3b82f6 !important; /* Azul moderno (estilo Tailwind/Bootstrap) */
  font-weight: bold;
  opacity: 1;
}

/* [EXPERT_UI]: Reemplazo de Icono por Máscara SVG (Flecha Doble Punta Sólida) */
.p-datatable .p-sortable-column-icon::before {
  content: "" !important;
  display: inline-block !important;
  width: 14px !important;
  height: 14px !important;
  background-color: currentColor !important;

  /* SVG Data URI para una flecha sólida de doble punta */
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/contain no-repeat;

  font-family: serif !important; /* Reset */
  font-size: 1rem !important;
}

/* Ajuste de alineación del contenedor del icono */
.p-datatable .p-sortable-column-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

/* Ajuste adicional para el estado activo para mantener consistencia */
.p-datatable
  .p-datatable-thead
  > tr
  > th.p-highlight
  .p-sortable-column-icon::before {
  /* Mantenemos el mismo icono o dejamos que cambie al de orden asc/desc específico si PrimeReact lo hace por clase */
  /* PrimeReact cambia la clase del <i> a pi-sort-amount-up-alt, etc. 
       Si forzamos content aquí, podríamos perder la indicación de dirección.
       Pero como estamos apuntando a .p-sortable-column-icon (que es la clase base), 
       necesitamos asegurar que si tiene clase específica (pi-sort-amount-...) no se sobrescriba incorrectamente
       O aceptamos que "pi-sort-alt" sea el base neutral.
    */
}

/* [EXPERT] Centrar horizontalmente el contenido de todas las celdas de datos y fijar altura */
.pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.15rem 0.1rem !important; /* [EXPERT_FIX]: Padding reducido para columnas estrechas (ID) */
  height: 44px !important; /* [EXPERT_FIX]: Altura aumentada 6px por solicitud de usuario */
  font-size: 0.85rem !important; /* Texto un poco más compacto */
}

.p-datatable .p-column-title {
  display: inline-block !important;
  line-height: 1.1 !important;
}

/* ============================================
   MEDIA QUERIES - RESPONSIVIDAD
   ============================================ */

/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */
@media (max-width: 1024px) {
  .pagina-pedidos.contenedorprincipal {
    width: 98%;
  }

  .pagina-pedidos .botonessuperiores {
    flex-wrap: wrap;
    gap: 8px;
  }

  .pagina-pedidos .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.8rem;
    padding: 0.25rem !important;
  }

  .pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.85rem;
    padding: 0.25rem !important;
    height: 42px !important;
  }

  .botonessuperiores .p-button {
    padding: 4px 8px;
    font-size: 0.85rem;
  }
}

/* === TABLETS (768px y menores) === */
@media (max-width: 768px) {
  .pagina-pedidos.contenedorprincipal {
    width: 100%;
    padding: 5px;
  }

  .pagina-pedidos .titulo {
    font-size: 1.2rem;
    margin-bottom: 8px;
  }

  .pagina-pedidos .botonessuperiores {
    flex-direction: column;
    gap: 8px;
  }

  .pagina-pedidos .botonessuperiores .p-button {
    width: 100%;
    justify-content: center;
  }

  /* Scroll horizontal mejorado para tablas */
  .pagina-pedidos .p-datatable-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 280px; /* Reducido para móviles para asegurar visibilidad del paginador */
  }

  /* Indicador visual de scroll */
  .pagina-pedidos .p-datatable-wrapper::after {
    content: "← Desliza para ver más →";
    display: block;
    text-align: center;
    padding: 6px;
    background: #fff3cd;
    font-size: 0.8rem;
    color: #856404;
    border-top: 1px solid #ffeaa7;
  }

  /* Ocultar columnas secundarias en móvil */
  .pagina-pedidos .p-datatable th:nth-child(9),  /* Observaciones */
  .pagina-pedidos .p-datatable td:nth-child(9),
  .pagina-pedidos .p-datatable th:nth-child(10), /* Peso Neto */
  .pagina-pedidos .p-datatable td:nth-child(10),
  .pagina-pedidos .p-datatable th:nth-child(12), /* Descripción mercancía */
  .pagina-pedidos .p-datatable td:nth-child(12) {
    display: none !important;
  }

  /* Ajustar input de búsqueda */
  .pagina-pedidos .p-input-icon-left {
    width: 100%;
  }

  .pagina-pedidos .p-input-icon-left input {
    width: 100%;
  }
}

/* === MÓVILES PEQUEÑOS (480px y menores) === */
@media (max-width: 480px) {
  .pagina-pedidos .titulo {
    font-size: 1rem;
    margin-bottom: 10px;
  }

  .pagina-pedidos .botonessuperiores .p-button {
    font-size: 0.8rem;
    padding: 8px;
  }

  .pagina-pedidos .p-datatable .p-datatable-thead > tr > th {
    font-size: 0.75rem;
    padding: 0.2rem !important;
  }

  .pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.75rem;
    padding: 0.2rem !important;
    height: 38px !important;
  }

  /* Ocultar columnas adicionales en móviles muy pequeños */
  .pagina-pedidos .p-datatable th:nth-child(8),  /* Peso Bruto */
  .pagina-pedidos .p-datatable td:nth-child(8),
  .pagina-pedidos .p-datatable th:nth-child(11), /* CBM */
  .pagina-pedidos .p-datatable td:nth-child(11) {
    display: none !important;
  }

  /* Ajustar resumen de estados para móviles pequeños */
  .resumen-estados-container {
    font-size: 0.8rem;
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ListaPedidos.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAE,yEAAyE;AAC/F;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,4CAA4C;EAC3D,uBAAuB,EAAE,0CAA0C;EACnE,QAAQ,EAAE,gCAAgC;EAC1C,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,iBAAiB,EAAE,6CAA6C;EAChE,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;uCAEuC;AACvC;EACE,cAAc,EAAE,kEAAkE;EAClF,WAAW,EAAE,wCAAwC;EACrD,kBAAkB,EAAE,sCAAsC;EAC1D,yBAAyB,EAAE,qBAAqB;EAChD,gBAAgB,EAAE,iCAAiC;EACnD,iBAAiB,EAAE,0BAA0B;EAC7C,kBAAkB,EAAE,uBAAuB;EAC3C,sBAAsB,EAAE,oDAAoD;EAC5E,kBAAkB,EAAE,0CAA0C;EAC9D,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD,qEAAqE;AACrE;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE;IACE,WAAW,EAAE,mCAAmC;IAChD,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,yCAAyC;EACnD,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,oGAAoG;AACpG;EACE,8BAA8B,EAAE,oDAAoD;EACpF,eAAe,EAAE,mDAAmD;AACtE;;AAEA,+EAA+E;AAC/E;EACE,iBAAiB,EAAE,6DAA6D;AAClF;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,uFAAuF;AACvF;EACE,8BAA8B,EAAE,4BAA4B;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB,EAAE,oCAAoC;EACzD,kCAAkC;EAClC,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA,wEAAwE;AACxE;EACE,6BAA6B,EAAE,iCAAiC;EAChE,sBAAsB,EAAE,qCAAqC;EAC7D,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,yBAAyB,EAAE,6CAA6C;EACxE,iBAAiB;EACjB,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;;EAEzC,uDAAuD;EAGvD;4BAC0B;;EAE1B,6BAA6B,EAAE,UAAU;EACzC,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;;;;;EAKE,mHAAmH;EACnH;;;;;KAKG;AACL;;AAEA,8FAA8F;AAC9F;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kCAAkC,EAAE,gEAAgE;EACpG,uBAAuB,EAAE,gEAAgE;EACzF,6BAA6B,EAAE,+BAA+B;AAChE;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB,EAAE,kEAAkE;EACvF;;EAEA,+BAA+B;EAC/B;IACE,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;EAC/B;;EAEA,0CAA0C;EAC1C;;;;;;IAME,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA,yDAAyD;EACzD;;;;IAIE,wBAAwB;EAC1B;;EAEA,qDAAqD;EACrD;IACE,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":[".pagina-pedidos.contenedorprincipal {\n  width: 95%;\n  margin: 0 auto;\n  padding-bottom: 5px;\n  display: flex;\n  flex-direction: column;\n  position: relative; /* [EXPERT_FIX]: Necesario para que el resumen de estados se ancle aquí */\n}\n\n.pagina-pedidos .titulo {\n  text-align: center;\n  margin-top: 0px;\n  margin-bottom: 2px;\n}\n\n.pagina-pedidos .botonessuperiores {\n  display: flex; /* Usamos flexbox para alinear los botones */\n  justify-content: center; /* Centramos los botones horizontalmente */\n  gap: 5px; /* Espaciado entre los botones */\n  margin-bottom: 15px; /* Espaciado inferior para separar de otros elementos */\n}\n\n.botonessuperiores .p-button {\n  padding: 5px 10px; /* Reduce el padding interno de los botones */\n  font-size: 14px; /* tamaño del texto de los botones*/\n}\n\n.fila-seleccionada {\n  background-color: #e0f7fa !important;\n}\n\n/**************************ESTILOS PARA LOS ESTADOS DE LISTA PEDIDOS***************\n\n/* Estilo base para todos los estados */\n.estado {\n  display: block; /* Se comporta como un bloque que ocupa todo el ancho disponible */\n  width: 100%; /* Ocupa el 100% del ancho de la celda */\n  text-align: center; /* Centrar el texto dentro del fondo */\n  background-color: #d9d9d9; /* Fondo gris claro */\n  padding: 4px 2px; /* Espaciado interno optimizado */\n  font-weight: bold; /* Negrita para el texto */\n  border-radius: 5px; /* Bordes redondeados */\n  box-sizing: border-box; /* Asegura que el padding no afecte el ancho total */\n  font-size: 0.85rem; /* Tamaño de fuente ligeramente reducido */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Colores específicos según el estado */\n.estado-creado {\n  color: blue;\n}\n\n.estado-le-ok {\n  color: green;\n}\n\n.estado-le-aprobada {\n  color: rgb(255, 0, 0);\n}\n\n.estado-asignado {\n  color: darkorange;\n}\n\n.estado-cargado {\n  color: purple;\n}\n\n.estado-despachado {\n  color: rgb(129, 238, 129);\n}\n\n.estado-parcialmente-asignado {\n  color: #ff9800;\n}\n\n.estado-parcialmente-cargado {\n  color: #9c27b0;\n}\n\n.estado-parcialmente-despachado {\n  color: #f44336;\n}\n\n/*************Resumen estado pedidos***************/\n/* [EXPERT_FIX]: Renombrado a -panel para evitar cache y conflictos */\n.resumen-estados-panel {\n  /* Position absolute eliminado, manejado por wrapper en JSX */\n  width: 250px;\n  padding: 5px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  font-size: 0.9rem;\n}\n\n/* Media query para pantallas medianas y pequeñas */\n@media (max-width: 1024px) {\n  .resumen-estados-panel {\n    width: 100%; /* Ocupa todo el ancho disponible */\n    max-width: 100%;\n    margin-top: 10px;\n  }\n}\n\n.resumen-estado-item {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* Espaciado entre el ícono y el nombre */\n  padding: 2px 0;\n}\n\n.p-datatable-header {\n  padding: 0.5rem;\n}\n\n/* [EXPERT] Forzar layout para que el ancho de las columnas se respete y permita scroll horizontal */\n.pagina-pedidos .p-datatable .p-datatable-wrapper table {\n  table-layout: fixed !important; /* Cambiado de auto a fixed para mayor estabilidad */\n  min-width: 100%; /* Asegura que cubra al menos el ancho disponible */\n}\n\n/* [EXPERT] Establecer altura mínima para que el paginador no salte al buscar */\n.pagina-pedidos .p-datatable .p-datatable-wrapper {\n  min-height: 350px; /* Reducido para asegurar visibilidad del paginador al 100% */\n}\n\n.p-datatable .p-datatable-scrollable-header-table,\n.p-datatable .p-datatable-scrollable-body-table {\n  table-layout: fixed !important;\n}\n\n/* [EXPERT] Forzar que los encabezados de la tabla mantengan dos líneas y no colapsen */\n.pagina-pedidos .p-datatable .p-datatable-thead > tr > th {\n  white-space: normal !important; /* Permite saltos de línea */\n  word-wrap: break-word !important;\n  vertical-align: middle !important;\n  text-align: center !important;\n  padding: 0.35rem !important;\n}\n\n/* [EXPERT_UI]: Ajuste de layout seguro para encabezados */\n.p-datatable .p-datatable-thead > tr > th .p-column-header-content {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important; /* Más espacio entre texto e icono */\n  padding: 0.35rem 0.2rem !important;\n  position: relative; /* Para posicionamiento fino si fuera necesario */\n}\n\n/* [EXPERT_UI]: Estilización de Iconos de Ordenamiento \"Más Estéticos\" */\n.p-datatable .p-sortable-column-icon {\n  font-size: 0.75rem !important; /* Icono más pequeño y elegante */\n  color: #999 !important; /* Color gris suave, menos agresivo */\n  margin-left: 0 !important; /* Reset de margenes */\n  opacity: 0.7;\n  transition: all 0.2s ease;\n}\n\n/* Estado activo (columna ordenada) */\n.p-datatable .p-datatable-thead > tr > th.p-highlight .p-sortable-column-icon {\n  color: #3b82f6 !important; /* Azul moderno (estilo Tailwind/Bootstrap) */\n  font-weight: bold;\n  opacity: 1;\n}\n\n/* [EXPERT_UI]: Reemplazo de Icono por Máscara SVG (Flecha Doble Punta Sólida) */\n.p-datatable .p-sortable-column-icon::before {\n  content: \"\" !important;\n  display: inline-block !important;\n  width: 14px !important;\n  height: 14px !important;\n  background-color: currentColor !important;\n\n  /* SVG Data URI para una flecha sólida de doble punta */\n  -webkit-mask: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L6 8h3v8H6l6 6l6-6h-3V8h3L12 2z\" /></svg>')\n    center/contain no-repeat;\n  mask: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2L6 8h3v8H6l6 6l6-6h-3V8h3L12 2z\" /></svg>')\n    center/contain no-repeat;\n\n  font-family: serif !important; /* Reset */\n  font-size: 1rem !important;\n}\n\n/* Ajuste de alineación del contenedor del icono */\n.p-datatable .p-sortable-column-icon {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Ajuste adicional para el estado activo para mantener consistencia */\n.p-datatable\n  .p-datatable-thead\n  > tr\n  > th.p-highlight\n  .p-sortable-column-icon::before {\n  /* Mantenemos el mismo icono o dejamos que cambie al de orden asc/desc específico si PrimeReact lo hace por clase */\n  /* PrimeReact cambia la clase del <i> a pi-sort-amount-up-alt, etc. \n       Si forzamos content aquí, podríamos perder la indicación de dirección.\n       Pero como estamos apuntando a .p-sortable-column-icon (que es la clase base), \n       necesitamos asegurar que si tiene clase específica (pi-sort-amount-...) no se sobrescriba incorrectamente\n       O aceptamos que \"pi-sort-alt\" sea el base neutral.\n    */\n}\n\n/* [EXPERT] Centrar horizontalmente el contenido de todas las celdas de datos y fijar altura */\n.pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 0.15rem 0.1rem !important; /* [EXPERT_FIX]: Padding reducido para columnas estrechas (ID) */\n  height: 44px !important; /* [EXPERT_FIX]: Altura aumentada 6px por solicitud de usuario */\n  font-size: 0.85rem !important; /* Texto un poco más compacto */\n}\n\n.p-datatable .p-column-title {\n  display: inline-block !important;\n  line-height: 1.1 !important;\n}\n\n/* ============================================\n   MEDIA QUERIES - RESPONSIVIDAD\n   ============================================ */\n\n/* === TABLETS Y LAPTOPS PEQUEÑAS (1024px y menores) === */\n@media (max-width: 1024px) {\n  .pagina-pedidos.contenedorprincipal {\n    width: 98%;\n  }\n\n  .pagina-pedidos .botonessuperiores {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .pagina-pedidos .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.8rem;\n    padding: 0.25rem !important;\n  }\n\n  .pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.85rem;\n    padding: 0.25rem !important;\n    height: 42px !important;\n  }\n\n  .botonessuperiores .p-button {\n    padding: 4px 8px;\n    font-size: 0.85rem;\n  }\n}\n\n/* === TABLETS (768px y menores) === */\n@media (max-width: 768px) {\n  .pagina-pedidos.contenedorprincipal {\n    width: 100%;\n    padding: 5px;\n  }\n\n  .pagina-pedidos .titulo {\n    font-size: 1.2rem;\n    margin-bottom: 8px;\n  }\n\n  .pagina-pedidos .botonessuperiores {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .pagina-pedidos .botonessuperiores .p-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  /* Scroll horizontal mejorado para tablas */\n  .pagina-pedidos .p-datatable-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    min-height: 280px; /* Reducido para móviles para asegurar visibilidad del paginador */\n  }\n\n  /* Indicador visual de scroll */\n  .pagina-pedidos .p-datatable-wrapper::after {\n    content: \"← Desliza para ver más →\";\n    display: block;\n    text-align: center;\n    padding: 6px;\n    background: #fff3cd;\n    font-size: 0.8rem;\n    color: #856404;\n    border-top: 1px solid #ffeaa7;\n  }\n\n  /* Ocultar columnas secundarias en móvil */\n  .pagina-pedidos .p-datatable th:nth-child(9),  /* Observaciones */\n  .pagina-pedidos .p-datatable td:nth-child(9),\n  .pagina-pedidos .p-datatable th:nth-child(10), /* Peso Neto */\n  .pagina-pedidos .p-datatable td:nth-child(10),\n  .pagina-pedidos .p-datatable th:nth-child(12), /* Descripción mercancía */\n  .pagina-pedidos .p-datatable td:nth-child(12) {\n    display: none !important;\n  }\n\n  /* Ajustar input de búsqueda */\n  .pagina-pedidos .p-input-icon-left {\n    width: 100%;\n  }\n\n  .pagina-pedidos .p-input-icon-left input {\n    width: 100%;\n  }\n}\n\n/* === MÓVILES PEQUEÑOS (480px y menores) === */\n@media (max-width: 480px) {\n  .pagina-pedidos .titulo {\n    font-size: 1rem;\n    margin-bottom: 10px;\n  }\n\n  .pagina-pedidos .botonessuperiores .p-button {\n    font-size: 0.8rem;\n    padding: 8px;\n  }\n\n  .pagina-pedidos .p-datatable .p-datatable-thead > tr > th {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n  }\n\n  .pagina-pedidos .p-datatable .p-datatable-tbody > tr > td {\n    font-size: 0.75rem;\n    padding: 0.2rem !important;\n    height: 38px !important;\n  }\n\n  /* Ocultar columnas adicionales en móviles muy pequeños */\n  .pagina-pedidos .p-datatable th:nth-child(8),  /* Peso Bruto */\n  .pagina-pedidos .p-datatable td:nth-child(8),\n  .pagina-pedidos .p-datatable th:nth-child(11), /* CBM */\n  .pagina-pedidos .p-datatable td:nth-child(11) {\n    display: none !important;\n  }\n\n  /* Ajustar resumen de estados para móviles pequeños */\n  .resumen-estados-container {\n    font-size: 0.8rem;\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
